import 'twin.macro';
import 'styled-components/macro';

const ToyShop = () => {
  return (
    <div>
      <h1 tw="display-1">Welcome to the Toy Shop!</h1>
      <p>Clicking one of the items above will show you the stock.</p>
    </div>
  );
};

export default ToyShop;
